import { Phone, Globe, Instagram, Facebook } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-forest text-cream pt-24 pb-10 overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute -top-32 left-1/2 -translate-x-1/2 h-[420px] w-[420px] rounded-full bg-[#8A9A86]/15 blur-3xl"
      />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <div className="text-center">
          <p className="text-[11px] tracking-eyebrow uppercase text-cream/60">
            Align Wellness
          </p>
          <h3 className="mt-6 font-serif-display italic text-5xl sm:text-6xl lg:text-7xl leading-[1.05]">
            Heal · Release · Rise
          </h3>
          <p className="mt-6 max-w-xl mx-auto text-cream/70 leading-relaxed">
            A wellness &amp; transformation space guided by Tammy. Make the
            unconscious, conscious — and meet the version of you who has been
            quietly waiting.
          </p>
        </div>

        <div className="mt-16 grid sm:grid-cols-3 gap-8 text-sm">
          <a
            href="tel:+12507845104"
            data-testid="footer-phone"
            className="flex items-start gap-4 group"
          >
            <span className="h-10 w-10 rounded-full bg-cream/10 flex items-center justify-center group-hover:bg-[#D8B4A0]/40 transition-colors">
              <Phone size={15} />
            </span>
            <div>
              <p className="text-[11px] tracking-eyebrow uppercase text-cream/55">
                Call &amp; Text
              </p>
              <p className="mt-1 font-serif-display text-xl">250-784-5104</p>
            </div>
          </a>
          <a
            href="https://www.alignwithtammy.com"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-website"
            className="flex items-start gap-4 group"
          >
            <span className="h-10 w-10 rounded-full bg-cream/10 flex items-center justify-center group-hover:bg-[#D8B4A0]/40 transition-colors">
              <Globe size={15} />
            </span>
            <div>
              <p className="text-[11px] tracking-eyebrow uppercase text-cream/55">
                Website
              </p>
              <p className="mt-1 font-serif-display text-xl">
                alignwithtammy.com
              </p>
            </div>
          </a>
          <div className="flex items-start gap-4">
            <span className="h-10 w-10 rounded-full bg-cream/10 flex items-center justify-center">
              <Instagram size={15} />
            </span>
            <div>
              <p className="text-[11px] tracking-eyebrow uppercase text-cream/55">
                Follow along
              </p>
              <div className="mt-1 flex items-center gap-4">
                <a
                  href="https://www.instagram.com/alignwithtammy/"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-instagram"
                  className="font-serif-display text-xl hover:text-[#D8B4A0] transition-colors"
                >
                  Instagram
                </a>
                <span className="text-cream/30">·</span>
                <a
                  href="https://www.facebook.com/profile.php?id=61592401048091"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-facebook"
                  className="font-serif-display text-xl hover:text-[#D8B4A0] transition-colors inline-flex items-center gap-1"
                >
                  <Facebook size={14} /> Facebook
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-cream/15 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-cream/55">
          <p>© {year} Align Wellness · Guided by Tammy. All rights reserved.</p>
          <p className="tracking-eyebrow uppercase">
            Made with care · Heal Your Life
          </p>
        </div>
      </div>
    </footer>
  );
}
